export type Pt = [number, number];

export function roundedPolygonPath(points: Pt[], radius: number): string {
  const n = points.length;
  const segments: string[] = [];

  for (let i = 0; i < n; i += 1) {
    const prev = points[(i + n - 1) % n];
    const curr = points[i];
    const next = points[(i + 1) % n];

    const dxPrev = curr[0] - prev[0];
    const dyPrev = curr[1] - prev[1];
    const lenPrev = Math.hypot(dxPrev, dyPrev);
    const dxNext = next[0] - curr[0];
    const dyNext = next[1] - curr[1];
    const lenNext = Math.hypot(dxNext, dyNext);

    const r = Math.min(radius, lenPrev / 2, lenNext / 2);

    const ax = curr[0] - (dxPrev / lenPrev) * r;
    const ay = curr[1] - (dyPrev / lenPrev) * r;
    const bx = curr[0] + (dxNext / lenNext) * r;
    const by = curr[1] + (dyNext / lenNext) * r;

    segments.push(
      i === 0 ? `M ${ax},${ay}` : `L ${ax},${ay}`,
      `Q ${curr[0]},${curr[1]} ${bx},${by}`,
    );
  }
  segments.push("Z");
  return segments.join(" ");
}
